export function LiquidityProvider() {
    const textClasses = 'mb-4 leading-loose text-black text-xl font-light'
    return (
        <div className={'mt-16'}>
            <h1>Liquidity Pools</h1>
            <h4 className={`${textClasses} w-1/2`}>
                Onboarding for liquidity providers is coming soon! You will be
                notified when the program launches if you sign up to the
                waitlist linked in the Intercom popup in the bottom right of
                your screen.
            </h4>
            <p className={`${textClasses}`}>
                Alternativly check back here soon!
            </p>
        </div>
    )
}
